import React from 'react';
import './Attribution.css';
import CheckIcon from '@material-ui/icons/Check';
import { filterUsers } from './utils';

const StepButtons = ({ activeStep, stepOptions, setActiveStep, steps, selectedParent = {}, users }) => {
    return (
        <div className="step-buttons-container" style={{textAlign:'center'}}>
            {stepOptions.map((option, index) => {
                const label = option.label?.toLowerCase();
                if (index < 3) {
                    const nbUser = filterUsers(users, option, selectedParent)?.length || 0;
                    return (
                        <React.Fragment key={index}>
                            <div
                                className={`step-button ${option.colorClass} ${option.type === activeStep?.type ? 'step-button-active' : 'step-button-inactive'}`}
                                onClick={(e) => { setActiveStep(steps.find(step => step.type === option.type)); }}
                                style={{ cursor: 'pointer', padding : 5,}}
                            >
                                <span style={{ fontSize: '14px' }}>{option.label}</span>
                                {index + 1 < stepOptions.length &&
                                    (Number(nbUser) === 0 && index < 2) ? (
                                    <CheckIcon style={{ fontSize: '12px', cursor: 'default' }} />
                                ) : (
                                    <span
                                        style={{ fontSize: '9px', cursor: 'default' }}
                                        title={
                                            `${nbUser} bénévole${nbUser > 1 ? 's' : ''} ${nbUser > 1 ? 'sont' : 'est'} ${label} dans ${selectedParent?.nom?.toLowerCase()}`
                                        }
                                    >
                                        {nbUser}
                                    </span>
                                )
                                }
                            </div>
                            {index < 3 - 1 && <div className="step-line" />}
                        </React.Fragment>
                    )
                } else {
                    return '';
                }
            })}
        </div>
    );
};

export default StepButtons;
